'use strict';
export default function routes($stateProvider) {
    'ngInject';
    $stateProvider.state('bannerPreview', {
        url: '/shop/langing-page-preview/:bannerId',
        template: '<ee-banner-preview [banner-id]="$ctrl.bannerId" (action-triggered)="$ctrl.onBannerClicked($event)"></ee-banner-preview>',
        controller: function ($stateParams, BannerClickProcessor) {
            'ngInject';
            this.bannerId = $stateParams.bannerId;
            this.onBannerClicked = function (data) { return BannerClickProcessor.process(data); };
        },
        controllerAs: '$ctrl'
    });
    // State for filtered/advanced search
    $stateProvider.state('advSearchResults', {
        url: '/shop/search?ff?fft?term?page?sort?order?new?d?c?s?a?b?dc?q?df?ds?ii?ei',
        template: require('./search-results/search-results.html'),
        controller: 'SearchResultsController',
        controllerAs: 'vm',
        resolve: {
            profileData: function ($http) {
                return $http.get('/api/account')
                    .then(function (data) {
                    return data;
                })
                    .catch(function (err) {
                    return err;
                });
            },
            filterData: function (FilterService) {
                FilterService.getFilterMap();
            },
        },
    });
    // State for landing page searches such as /shop/Adrenal-and-Stress_D1
    $stateProvider.state('searchResults', {
        url: '/shop/:searchFilter',
        template: require('./search-results/search-results.html'),
        controller: 'SearchResultsController',
        controllerAs: 'vm',
        resolve: {
            profileData: function ($http) {
                return $http.get('/api/account')
                    .then(function (data) {
                    return data;
                })
                    .catch(function (error) {
                    return error;
                });
            },
            filterData: function (FilterService) {
                FilterService.getFilterMap();
            },
        },
    });
}
//# sourceMappingURL=search.routes.js.map